var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('Menu'),_c('div',{class:`content ${_vm.logged ? 'logged' : ''}`},[_vm._t("default")],2)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":require("@/assets/logo.svg"),"alt":""}})])
}]

export { render, staticRenderFns }